import {connect} from 'react-redux';
import React from 'react';

import Icon from '../../elements/icons/Icon';
import Link from '../../elements/Link';
import ListItem from '../../elements/DEPRECATED_ListItem';
import LoadParticipants from '../../loaders/LoadParticipants';
import Screen from '../Screen';
import ScreenTitle from '../../elements/ScreenTitle/ScreenTitle';
import Scrollable from '../../elements/Scrollable';
import TopBarEvent from '../../elements/TopBar/TopBarEvent';
import UserAvatar from '../../elements/icons/UserAvatar';
import Validate from '../../validate/Validate';
import WaitWhileBusy from '../../WaitWhileBusy';

class EventQuestsCategoryParticipants extends React.Component {
    render() {
        let {i18n, event, category} = this.props,
            header = (
                <div className="header">
                    <TopBarEvent event={event} returnURL="..">
                        {i18n['label.group-members']}
                    </TopBarEvent>
                    <ScreenTitle event={event} screen={category.label} />
                    <hr />
                </div>
            );

        return (
            <Screen header={header}>
                <Scrollable>
                    <div className="content">
                        {this.props.active.length ? <h2>{i18n['label.Active']}</h2> : null}
                        {this.props.active.map(participant => this.renderParticipant(participant))}
                        {this.props.active.length && this.props.inactive.length ? <hr className="marginTop marginBottom" /> : null}
                        {this.props.inactive.map(participant => this.renderParticipant(participant))}
                    </div>
                </Scrollable>
            </Screen>
        );
    }
    renderParticipant(participant) {
        let {event, i18n} = this.props;
        return (
            <ListItem tagName="div" key={participant.id}>
                <Link href={_.compact(['.', participant.id || '-', participant.participant_id || '-']).join('/')}>
                    <div className="Participant">
                        <UserAvatar user={participant} size={50} className="avatar" />
                        <div className="text has-icon-right">
                            <div className="username text name">
                                {participant.first_name} {participant.last_name}
                            </div>
                            {participant._questionsCount > 0 ? (
                                <div className="text small">
                                    {(participant._questionsCount == 1 ? i18n['label.count-comment'] : i18n['label.count-comments']).replace(
                                        '{0}',
                                        participant._questionsCount
                                    )}
                                </div>
                            ) : null}
                            {participant._answersCount > 0 ? (
                                <div className="text small">
                                    {(participant._answersCount == 1 ? i18n['label.count-reply'] : i18n['label.count-replies']).replace(
                                        '{0}',
                                        participant._answersCount
                                    )}
                                </div>
                            ) : null}

                            {participant._badge ? (
                                <Icon className="icon-right vertical-center" src={participant._badge} size={40} color={event.settings.primary_color} />
                            ) : null}
                        </div>
                    </div>
                </Link>
            </ListItem>
        );
    }
}

const EventQuestsCategoryParticipantsConnected = connect((state, props) => {
    let event = state.events[props.eventId].event,
        category = _(event.question_categories).find({id: parseInt(props.qcatId)}),
        catId = category.id,
        questions = _(state.events[props.eventId].questions.listed).filter({category_id: catId}),
        participants = _(state.events[props.eventId].participants.listed)
            .filter(p => {
                return p.in_question_categories && p.in_question_categories.indexOf(catId) != -1;
            })
            .map(p => {
                return {
                    ...p,
                    _questionsCount: _.get(p, 'active_in_question_categories[' + catId + '][0]', 0),
                    _answersCount: _.get(p, 'active_in_question_categories[' + catId + '][1]', 0),
                };
            })
            .sortBy(p => {
                // console.log(p);
                return -1 * (p._questionsCount + p._answersCount);
            })
            .value();

    // add badges
    _(participants)
        .slice(0, 3)
        .each((p, i) => {
            if (p._questionsCount || p._answersCount) {
                p._badge = 'img/ribbon_' + (i + 1).toString() + '.png';
            }
        });

    return {
        participants,
        active: _(participants)
            .filter(p => {
                return (p._questionsCount + p._answersCount);
            })
            // .sortBy('sortstring')
            .value(),
        inactive: _(participants)
            .filter(p => {
                return !(p._questionsCount + p._answersCount);
            })
            .sortBy('sortstring')
            .value(),
        event,
        category,
        i18n: state.i18n.translations,
    };
})(EventQuestsCategoryParticipants);

export default props => (
    <Validate
        validate={state => {
            let event = state.events[props.match.params.eventId].event;

            let category = _(event.question_categories).find({id: parseInt(props.match.params.qcatId)});
            if (!category) {
                throw new Error('Category not found: ' + props.match.params.qcatId);
            }
        }}
        key={props.location.pathname}>
        <LoadParticipants eventId={props.match.params.eventId}>
            <WaitWhileBusy>
                <EventQuestsCategoryParticipantsConnected {...props.match.params} />
            </WaitWhileBusy>
        </LoadParticipants>
    </Validate>
);
